// src/pages/Encaissement.js
import React, { useEffect, useState } from "react";
import API_URL from "../config";
import "./Encaissement.css"; // fichier CSS dédié

export default function Encaissement({ entrepriseId, siteId, entrepriseNom }) {
  const [encaissements, setEncaissements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchEncaissements = async () => {
    if (!entrepriseId || !siteId) return;

    setLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/api/transfert/encaissement?entrepriseId=${entrepriseId}&siteId=${siteId}`
      );
      if (!res.ok) throw new Error("Erreur récupération encaissements");
      const data = await res.json();

      // Trier par date décroissante (plus récent en haut)
      data.sort((a, b) => new Date(b.date_encaissement) - new Date(a.date_encaissement));
      setEncaissements(data);
    } catch (err) {
      console.error("[fetchEncaissements] erreur", err);
      setError(err.message || "Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEncaissements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entrepriseId, siteId]);

  const formatDate = (d) => {
    try {
      const dt = new Date(d);
      return dt.toLocaleDateString();
    } catch {
      return d;
    }
  };

  return (
    <div className="encaissement-page">
      <h2 className="page-title">
        Encaissements {entrepriseNom ? `— ${entrepriseNom}` : ""}
      </h2>

      {error && <div className="error">{error}</div>}

      <div className="table-wrapper">
        <table className="encaissement-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Montant</th>
              <th>Motif</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3} className="center">
                  Chargement...
                </td>
              </tr>
            ) : encaissements.length === 0 ? (
              <tr>
                <td colSpan={3} className="center">
                  Aucun encaissement
                </td>
              </tr>
            ) : (
              encaissements.map((e, index) => (
                <tr key={e.id} className={index === 0 ? "recent-row" : ""}>
                  <td>{formatDate(e.date_encaissement)}</td>
                  <td className={index === 0 ? "montant" : ""}>
                    {e.montant ?? "–"}
                  </td>
                  <td>{e.motif ?? "–"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
